.container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--gray-bg);
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 40px 32px;
  background: var(--white);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  max-width: 320px;
  width: 100%;
}

.title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text);
  margin: 0;
}

.subtitle {
  font-size: 13px;
  color: var(--gray-text);
  margin: 0;
}

.loginButton {
  width: 100%;
  margin-top: 8px;
}

/* ── Magic-link form ─────────────────────────────────────────────── */

.divider {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  color: var(--gray-text);
  font-size: 12px;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--gray-border);
}

.magicLinkForm {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.magicLinkHint {
  font-size: 12px;
  color: var(--gray-text);
  text-align: center;
  line-height: 1.5;
  margin: 0;
}

.submitButton {
  width: 100%;
}

.codeSentNotice {
  font-size: 13px;
  color: var(--gray-text);
  text-align: center;
  line-height: 1.5;
}

.error {
  font-size: 13px;
  color: var(--red);
  text-align: center;
}

.textButton {
  background: none;
  border: none;
  padding: 0;
  color: var(--blue-light);
  font-size: 13px;
  cursor: pointer;
  text-decoration: underline;
  align-self: center;
}

.textButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.resendSuccess {
  font-size: 13px;
  color: var(--green);
  text-align: center;
  margin: 0;
}
